/**
 * Linear interpolation - calculates a value between a min and max range based on a percentage.
 *
 * @param {[number, number]} [a, b] - Tuple containing the start and end values of the range.
 * @param {number} percent - The interpolation factor (0 = start value, 1 = end value).
 * @returns {number} The interpolated value between the range.
 */
export const lerp = ([a, b]: [number, number], percent: number) => a + percent * (b - a);
